import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=10200f4c&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"
import style0 from "./Notification.vue?vue&type=style&index=0&id=10200f4c&prod&scoped=true&lang=css"
import style1 from "@/assets/css/group_dashboard/notification.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10200f4c",
  null
  
)

export default component.exports